import { render, staticRenderFns } from "./PwaUpdate.vue?vue&type=template&id=55f4e2d6"
import script from "./PwaUpdate.vue?vue&type=script&lang=js"
export * from "./PwaUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports